import {QualityNotificationRequest} from '../types/QualityNotificationCreateRequest'
import {
    BoneQualityOptions,
    ClinicalConditionOptions,
    ComplaintState,
    ComplaintTypeOptions,
    ImplantBrandOptions,
    InjuryTypeOptions,
    LocationOptions,
    PatientStatusOptions,
    ProductTypeOptions,
    ProfileOptions,
    ValueRatingOptions,
} from '../contexts/types'
import {readAsBinaryStringAsync} from "./attachment-utils";
import {db} from "./db";

const prepareComplaintRequestData = async (complaint: ComplaintState) => {
    let complaintRequestData: QualityNotificationRequest =
        await mapUiToSapFields(complaint)

    return complaintRequestData
}

const mapUiToSapFields = async (complaint: ComplaintState) => {
    let complaintRequest: QualityNotificationRequest =
        getDefaultComplaintRequest()

    complaintRequest = {
        ...complaintRequest,
        ...mapGeneralInfoFields(complaint, complaintRequest),
    }
    complaintRequest = {
        ...complaintRequest,
        ...mapGeneralComplaintFields(complaint, complaintRequest),
    }
    complaintRequest = {
        ...complaintRequest,
        ...mapComplaintTypeFields(complaint, complaintRequest),
    }
    complaintRequest = {
        ...complaintRequest,
        ...mapTreatmentDates(complaint, complaintRequest),
    }
    complaintRequest = {
        ...complaintRequest,
        ...mapPatientInformation(complaint, complaintRequest),
    }
    complaintRequest = {
        ...complaintRequest,
        ...await mapComplaintType(complaint, complaintRequest),
    }
    complaintRequest = {
        ...complaintRequest,
        ...mapClinicalConditions(complaint, complaintRequest),
    }
    complaintRequest = {
        ...complaintRequest,
        ...mapAbutmentInfo(complaint, complaintRequest),
    }
    complaintRequest = {
        ...complaintRequest,
        ...mapInstrumentInfo(complaint, complaintRequest),
    }
    complaintRequest = {
        ...complaintRequest,
        ...mapSecondaryDeviceInfo(complaint, complaintRequest),
    }
    complaintRequest = {
        ...complaintRequest,
        ...await mapMainProductAvailableToReturn(complaint, complaintRequest),
    }
    complaintRequest = {
        ...complaintRequest,
        ...mapProductReplacements(complaint, complaintRequest),
    }
    complaintRequest = {
        ...complaintRequest,
        ...mapAcknowledgement(complaint, complaintRequest),
    }
    complaintRequest = {
        ...complaintRequest,
        ...mapCustomerNumber(complaint, complaintRequest)
    }
    complaintRequest = {
        ...complaintRequest,
        ...mapCountryCode(complaint, complaintRequest)
    }
    complaintRequest = {
        ...complaintRequest,
        frontendState: complaint,
    }
    return complaintRequest
}

const mapCustomerNumber = (
    complaint: ComplaintState,
    complaintRequest: QualityNotificationRequest
) => {

    complaintRequest.customerNumber = complaint.guestInfo.customerNumber || complaint.shippingInfo.customer?.customer || ''
    return complaintRequest
}

const mapCountryCode = (
    complaint: ComplaintState,
    complaintRequest: QualityNotificationRequest
) => {

    complaintRequest.countryCode = complaint.guestInfo.country as string

    return complaintRequest
}

const mapGeneralInfoFields = (
    complaint: ComplaintState,
    complaintRequest: QualityNotificationRequest
) => {
    if (complaintRequest.customer) {
        complaintRequest.customer.contactName =
            complaint.generalInfo.contactName
    }

    return complaintRequest
}

const mapGeneralComplaintFields = (
    complaint: ComplaintState,
    complaintRequest: QualityNotificationRequest
) => {
    if (complaintRequest.product) {
        // Product search: Enter article number or description
        complaintRequest.product.articleNo =
            complaint.generalComplaint.selectedProduct?.productId

        // Select product type: Do you know the batch or lot number?
        complaintRequest.product.batchNo =
            complaint.generalComplaint.batchOrLotNumber?.trim().length === 0
                ? 'Not Available'
                : complaint.generalComplaint.batchOrLotNumber?.trim()

        // Select product type: Would you like product to be replaced?
        complaintRequest.product.productReplacementRequired =
            complaint.generalComplaint.isReplacementNeeded === 'YES'
    } else if (complaintRequest.product === undefined) {

        // INITIALIZE
        complaintRequest.product = {}
        // THEN SET
        complaintRequest.product.productReplacementRequired =
            complaint.generalComplaint.isReplacementNeeded === 'YES'
    }
    if (complaintRequest.clinicalProcedure) {
        // Select product type: Was the product placed in the patient's mouth?
        complaintRequest.clinicalProcedure.neverPlaced =
            complaint.generalComplaint.wasProductPlaced === 'NO'
    }

    if (complaintRequest.issue) {
        // Select product type: Was a patient involved?
        complaintRequest.issue.patientUsed =
            complaint.generalComplaint.wasPatientInvolved === 'YES'

        // Select product type: Select product type:
        complaintRequest.issue.productType = mapProductTypeOptions(
            complaint.generalComplaint.productType
        )
    }

    if (complaintRequest.implant) {
        // Select product type: Was the implant dropped or opened in error?
        complaintRequest.implant.implantOpenedOrDroppedByError = (

            complaint.generalComplaint.wasOpenedOrDropped === 'YES'
        )

        complaintRequest.implant.wasAnotherImplantPlacedSameSite = (

            complaint.generalComplaint.wasAnotherImplantPlaced === 'YES'
                ? true
                : complaint.generalComplaint.wasAnotherImplantPlaced === 'NO'
                    ? false
                    : undefined
        )
    }


    return complaintRequest
}

const mapProductTypeOptions = (complaintProductType?: ProductTypeOptions) => {
    if (complaintProductType) {
        switch (complaintProductType) {
            case 'IMPLANT':
                return 'Implant'
            case 'ABUTMENT':
                return 'Abutment'
            case 'SCREW':
                return 'Screw'
            case 'CLINICAL_INSTRUMENT':
                return 'ClinicalInstrument'
            case 'LAB_INSTRUMENT_LAB_SCREW':
                return 'LabInstrument'
        }
    } else {
        return undefined
    }
}

const mapComplaintTypeFields = (
    complaint: ComplaintState,
    complaintRequest: QualityNotificationRequest
) => {
    // Event occurrence: Select date of occurrence:
    if (complaintRequest.clinicalProcedure) {
        complaintRequest.clinicalProcedure.eventDate = complaint.complaintType
            .dateOfOccurrence as Date
    }

    // Event occurrence: Select location:
    if (complaintRequest.issue) {
        complaintRequest.issue.eventOccurence = mapEventLocationOptions(
            complaint.complaintType.location
        )
    }

    return complaintRequest
}

const mapEventLocationOptions = (complaintEventLocation?: LocationOptions) => {
    if (complaintEventLocation) {
        switch (complaintEventLocation) {
            case '1_LAB_INITIAL_INSPECTION':
                return 'LabInitialInspection'
            case '2_LAB_DURING_FINALIZATION':
                return 'LabDuringFinalization'
            case '3_CLINIC_INITIAL_INSPECTION':
                return 'ClinicInitialInspection'
            case '4_CLINIC_DURING_PROCEDURE':
                return 'ClinicDuring'
            case '5_CLINIC_AFTER_PROCEDURE':
                return 'ClinicAfter'
        }
    } else {
        return undefined
    }
}

const mapTreatmentDates = (
    complaint: ComplaintState,
    complaintRequest: QualityNotificationRequest
) => {
    if (complaintRequest.clinicalProcedure) {
        // Treatment dates: Date of treatment:
        complaintRequest.clinicalProcedure.placementDate = complaint
            .treatmentDates.dateOfTreatment as Date

        // Treatment dates: Was implant loaded?
        complaintRequest.clinicalProcedure.noImplantLoad =
            complaint.treatmentDates.wasImplantLoaded === 'NO'

        // Treatment dates: Date of implant loading:
        complaintRequest.clinicalProcedure.implantLoadDate = complaint
            .treatmentDates.dateOfImplantLoading as Date

        // Treatment dates: Was there a second surgery?
        complaintRequest.clinicalProcedure.noSecondSurgery =
            complaint.treatmentDates.wasThereASecondSurgery === 'NO'

        // Treatment dates: Date of second surgery:
        complaintRequest.clinicalProcedure.secondSurgeryDate = complaint
            .treatmentDates.dateOfSecondSurgery as Date

        // Treatment dates: Was the product removed?
        complaintRequest.clinicalProcedure.removed =
            complaint.treatmentDates.wasProductRemoved === 'NO'

        // Treatment dates: Product removal date:
        complaintRequest.clinicalProcedure.removeDate = complaint.treatmentDates
            .dateProductWasRemoved as Date
    }

    return complaintRequest
}

const mapPatientInformation = (
    complaint: ComplaintState,
    complaintRequest: QualityNotificationRequest
) => {
    if (complaintRequest.patient) {
        // Patient information: Patient ID number or Initials:
        complaintRequest.patient.code = complaint.patientInfo.patientId

        // Patient information: Patient age:
        complaintRequest.patient.age = complaint.patientInfo.patientAge
            ? complaint.patientInfo.patientAge.toString()
            : undefined

        // Patient information: Patient weight:
        complaintRequest.patient.weight = complaint.patientInfo.patientWeight
            ? complaint.patientInfo.patientWeight.toString() + ' ' + complaint.patientInfo.patientWeightUnit
            : 'N/A'
        // Patient information: Patient sex:
        complaintRequest.patient.gender = complaint.patientInfo.patientSex

        // Patient information: Patient profile:
        complaintRequest.patient.patientProfile = mapPatientProfileOptions(
            complaint.patientInfo.patientProfile
        )

        // Patient information: Patient profile: Other: Please specify:
        complaintRequest.patient.patientProfileOther =
            complaint.patientInfo.patientProfileExplanation

        // Patient information: Hygiene around the implant:
        complaintRequest.patient.implantHygiene = mapComplaintHygieneOptions(
            complaint.patientInfo.hygiene
        )

        // Patient information: Did the device contribute to or cause patient injury?
        complaintRequest.patient.injured =
            complaint.patientInfo.didDeviceContributeToInjury === 'YES'

        // Patient information: Type of injury:
        complaintRequest.patient.injuryType = mapComplaintInjuryTypeOptions(
            complaint.patientInfo.typeOfInjury
        )

        // Patient information: Type of injury: Other: Please provide details regarding patient injury:
        complaintRequest.patient.injuryTypeText =
            complaint.patientInfo.typeOfInjuryExplanation

        // Patient information: Current patient status:
        complaintRequest.patient.status = mapComplaintPatientStatusOptions(
            complaint.patientInfo.currentPatientStatus
        )
    }

    if (complaintRequest.clinicalProcedure) {
        // Patient information: Bone quality at the time of implant placement:
        complaintRequest.clinicalProcedure.boneQuality =
            mapComplaintBoneQualityOptions(complaint.patientInfo.boneQuality)

        // Patient information: Bone quality at the time of implant placement: Other: Please specify
        complaintRequest.clinicalProcedure.boneQualityOther =
            complaint.patientInfo.boneQualityExplanation
    }

    if (complaintRequest.product) {
        // Patient information: Product location
        complaintRequest.product.toothPosition = `UTN-${complaint.patientInfo.utn}|FDI-${complaint.patientInfo.fdi}`
    }

    return complaintRequest
}

const mapComplaintPatientStatusOptions = (
    patientStatusOptions: PatientStatusOptions
) => {
    if (patientStatusOptions) {
        switch (patientStatusOptions) {
            case 'RECOVERED':
                return 'Recovered'
            case 'RECOVERED_WITH_IMPAIRMENT':
                return 'Impairment'
            case 'UNDER_TREATMENT':
                return 'Treatment'
            case 'UNKNOWN':
                return 'Unknown'
        }
    } else {
        return undefined
    }
}

const mapComplaintInjuryTypeOptions = (
    injuryTypeOptions?: InjuryTypeOptions
) => {
    if (injuryTypeOptions) {
        if (injuryTypeOptions === 'MEDICAL_SURGICAL_INTERVENTION') {
            return 'Intervention'
        }
        if (injuryTypeOptions === 'PERMANENT_IMPAIRMENT') {
            return 'Impairment'
        }
        if (injuryTypeOptions === 'OTHER') {
            return 'Other'
        }
    } else {
        return undefined
    }
}

const mapComplaintBoneQualityOptions = (
    boneQualityOptions: BoneQualityOptions
) => {
    if (boneQualityOptions) {
        switch (boneQualityOptions) {
            case 'TYPE_1':
                return 'I'
            case 'TYPE_2':
                return 'II'
            case 'TYPE_3':
                return 'III'
            case 'TYPE_4':
                return 'IV'
            case 'OTHER':
                return 'Unknown'
        }
    }
}

const mapComplaintHygieneOptions = (
    complaintHygieneOptions: ValueRatingOptions
) => {
    if (complaintHygieneOptions) {
        switch (complaintHygieneOptions) {
            case 'EXCELLENT':
                return 'Excellent'
            case 'FAIR':
                return 'Fair'
            case 'GOOD':
                return 'Good'
            case 'POOR':
                return 'Poor'
        }
    } else {
        return undefined
    }
}

const mapPatientProfileOptions = (
    complaintPatientProfileOptions?: ProfileOptions
) => {
    if (complaintPatientProfileOptions) {
        let profileOptions: string[] = []

        if (complaintPatientProfileOptions.BRUXER) {
            profileOptions.push('Bruxer')
        }
        if (complaintPatientProfileOptions.DIABETIC) {
            profileOptions.push('Diabetic')
        }
        if (complaintPatientProfileOptions.SMOKER) {
            profileOptions.push('Smoker')
        }
        if (complaintPatientProfileOptions.NONE) {
            profileOptions.push('None')
        }
        if (complaintPatientProfileOptions.UNKNOWN) {
            profileOptions.push('Unknown')
        }
        if (complaintPatientProfileOptions.OTHER) {
            profileOptions.push('Other')
        }
        return profileOptions
    } else {
        return undefined
    }
}

const mapComplaintType = async (
    complaint: ComplaintState,
    complaintRequest: QualityNotificationRequest
) => {
    if (complaintRequest.issue) {
        // Complaint type: Please select complaint type
        complaintRequest.issue.issueDefinition = mapComplaintTypeOptions(
            complaint.complaintType.complaintType
        )

        // Complaint type: Please select complaint type: Other product deficiencies or technical issues: Please explain:

        if (complaint.complaintType.surfaceDefectExplanation) {
            complaintRequest.issue.issueDefinitionOther =
                complaint.complaintType.surfaceDefectExplanation
        } else if (complaint.complaintType.otherExplanation) {
            complaintRequest.issue.issueDefinitionOther =
                complaint.complaintType.otherExplanation
        } else if (complaint.complaintType.otherExplanation) { // MAY NOT BE NEEDED ?
            complaintRequest.issue.issueDefinitionOther =
                complaint.complaintType.estheticExplanation
        } else if (complaint.complaintType.estheticExplanation) {
            complaintRequest.issue.issueDefinitionOther =
                complaint.complaintType.estheticExplanation
        }

        if (complaint.complaintType.attachmentIds) {
            let count = 0
            for (const attachmentId of complaint.complaintType.attachmentIds) {
                const file = await db.attachments.get(attachmentId)

                if (file) {
                    const binary = btoa(await readAsBinaryStringAsync(file.content) as string)
                    const extension = file.name.split('.')[file.name.split('.').length - 1]

                    complaintRequest.attachments = [...(complaintRequest.attachments || []), {
                        name: `complaintType-${++count}.${extension}`,
                        content: binary
                    }]
                }
            }
        }
    }
    return complaintRequest
}

const mapComplaintTypeOptions = (
    complaintTypeOptions: ComplaintTypeOptions,
) => {
    if (complaintTypeOptions) {
        switch (complaintTypeOptions) {
            case 'ARTIFIACTS_ON_IMAGE':
                return 'Artifacts on image'
            case 'CLINICAL_PROSTHETIC_SCREW_LOOSENING':
                return 'Clinical/ prosthetic screw loosening'
            case 'COATING_FLAKING_OFF':
                return 'Coating(s) flaking off'
            case 'COLOR_MISMATCHING':
                return 'Color mismatching'
            case 'DAMAGE_WITH_PACKAGING_INTACT':
                return 'Visual damage on the product with packaging intact'
            case 'DEFLECTION':
                return 'Deflection'
            case 'DEFORMED':
                return 'Part/Interface deformed'
            case 'DISCOLORATION':
                return 'Device De-/Discoloration '
            case 'DOES_NOT_DISENGAGE':
                return 'Part/Interface does not disengage'
            case 'DOES_NOT_ENGAGE':
                return 'Part/Interface does not engage'
            case 'DOES_NOT_FIT':
                return 'Part/Interface does not fit/align'
            case 'FOREIGN_PARTICLES':
                return 'Foreign particles on the product/in packaging'
            case 'FUNCTIONALITY_COMPROMISED':
                return 'Functionality compromised due to lost part or subcomponent'
            case 'HEATING':
                return 'Heating'
            case 'INADEQUATE_CLEANING_OF_PART':
                return 'Inadequate/difficult cleaning of a part'
            case 'INFORMATION_MISLEADING':
                return 'IFU information misleading/wrong'
            case 'INTERFACE_FRETTING':
                return 'Part/Interface fretting/corroding/rusting'
            case 'LABEL_ILLEGIBLE':
                return 'Label information illegible'
            case 'LABEL_INFORMATION_MISSING':
                return 'Label information missing'
            case 'LABEL_MISLEADING':
                return 'Label information misleading/wrong'
            case 'LACK_STABILITY':
                return 'Lack of primary stability'
            case 'MORE_THAN_365_DAYS':
                return 'Osseointegration issue occuring  after more than 365 days after implant insertion'
            case 'NOT_FUNCTIONAL':
                return 'Part not functional'
            case 'OTHER_DEFICIENCIES':
                return 'Other Product Deficiencies and Technical Issues'
            case 'OTHER_OUTCOME':
                return 'Other unsatisfactory esthetic outcome.'
            case 'PARTIALLY_VISIBLE':
                return 'Implant/Abutment partially visible'
            case 'PART_ASSEMBLY_ISSUE':
                return 'Part assembly issue'
            case 'PART_DISASSEMBLED':
                return 'Part disassembled in packaging'
            case 'PART_DISASSEMBLY_ISSUE':
                return 'Part disassembly issue'
            case 'PART_FRACTURED':
                return 'Part fractured'
            case 'PART_MIGRATES':
                return 'Part migrates '
            case 'PART_NOT_RETAINED':
                return 'Part not retained on mating Part (e.g. dropped)'
            case 'PREMATURE_WEAR':
                return 'Premature wear/tear'
            case 'SHINES_THROUGH':
                return 'Implant/Abutment shines through restoration/tissue'
            case 'STERILE_BARRIER_DAMAGED':
                return 'Sterile barrier system damaged'
            case 'SURFACE_CORRODED':
                return 'Surface corroded'
            case 'SURFACE_DEFECT':
                return 'Product - Surface defect (Please specify)'
            case 'TRANSLATION_MISSING':
                return 'Native IFU translation missing'
            case 'TRAUMA':
                return 'Trauma / Clinical Complication only'
            case 'UNABLE_TO_DISTINGUISH':
                return 'Unable to distingiush between different platform sizes'
            case 'WITHIN_365_DAYS':
                return 'Osseointegration issue occuring wtihin 365 days after implant insertion'
            case 'WRONG_PART':
                return 'Usability - Wrong part used'
            case 'WRONG_PART_PACKAGED':
                return 'Wrong or no part packaged'
        }
    } else {
        return undefined
    }
}

const mapClinicalConditions = (
    complaint: ComplaintState,
    complaintRequest: QualityNotificationRequest
) => {
    if (complaintRequest.clinicalProcedure) {
        // Clinical conditions: Please select a clinical condition:
        complaintRequest.clinicalProcedure.involvedConditions =
            mapComplaintClinicalConditionOptions(
                complaint.clinicalCondition.clinicalCondition
            )

        // Clinical conditions: Acute or transient pain: Has the pain disappeared after implant removal?
        if (complaint.clinicalCondition.hasPainDisappeared) {
            complaintRequest.clinicalProcedure.painNumbnessOffAtRemoval =
                complaint.clinicalCondition.hasPainDisappeared === 'YES'
        }

        // Clinical conditions: Numbness: Has the numbness disappeared after implant removal?
        if (complaint.clinicalCondition.hasNumbnessDisappeared) {
            complaintRequest.clinicalProcedure.painNumbnessOffAtRemoval =
                complaint.clinicalCondition.hasNumbnessDisappeared === 'YES'
        }

        // Clinical conditions: Please select a clinical condition: Prolonged surgery (please specify)
        complaintRequest.clinicalProcedure.prolongedSurgery =
            complaint.clinicalCondition.prolongedSurgeryExplanation

        // Clinical conditions: Please select a clinical condition: Prolonged treatment time (please specify)
        complaintRequest.clinicalProcedure.prolongedTreatmentTime =
            complaint.clinicalCondition.prolongedTreatmentExplanation

        // Clinical conditions: Please select a clinical condition: Other
        complaintRequest.clinicalProcedure.involvedConditionOther = (

            complaint.clinicalCondition.otherExplanation !== ''
                ? complaint.clinicalCondition.otherExplanation
                : complaint.clinicalCondition.permanentImpairmentExplanation !== ''
                    ? complaint.clinicalCondition.permanentImpairmentExplanation
                    : ''
        )

        if (complaint.clinicalCondition.wereNerveSymptomsAlleviated) {

            complaintRequest.clinicalProcedure.WereTheSymptomsAlleviatedOverTime = (

                complaint.clinicalCondition.wereNerveSymptomsAlleviated === 'YES'
                    ? true
                    : complaint.clinicalCondition.wereNerveSymptomsAlleviated === 'NO'
                        ? false
                        : undefined
            )
        }
    }

    return complaintRequest
}

const mapComplaintClinicalConditionOptions = (
    clinicalConditionOptions: ClinicalConditionOptions
) => {
    if (clinicalConditionOptions) {
        let options: string[] = []
        if (clinicalConditionOptions === 'ABSCESS') {
            options.push('Abscess')
        }
        if (clinicalConditionOptions === 'ALLERGIC_REACTION') {
            options.push('Allergic reaction')
        }
        if (clinicalConditionOptions === 'ASPIRATION') {
            options.push('Aspiration (medical device)')
        }
        if (clinicalConditionOptions === 'BONE_FRACTURE') {
            options.push('Bone fracture')
        }
        if (clinicalConditionOptions === 'DAMAGING_OF_BLOOD_VESSELS') {
            options.push('Damaging of blood vessels')
        }
        if (clinicalConditionOptions === 'DEATH') {
            options.push('Death (Patient/User)')
        }
        if (clinicalConditionOptions === 'FISTULA') {
            options.push('Fistula')
        }
        if (clinicalConditionOptions === 'HAMPERS_DIAGNOSTICS') {
            options.push('Hampers diagnostics (delayed/incorrect)')
        }
        if (clinicalConditionOptions === 'LOCAL_INFECTION') {
            options.push('Local infection')
        }
        if (clinicalConditionOptions === 'LOCAL_INFLAMMATION') {
            options.push('Local inflammation / immune response')
        }
        if (clinicalConditionOptions === 'NERVE_INJURY_SYMPTOMS') {
            options.push('Nerve injury symptoms')
        }
        if (clinicalConditionOptions === 'NONE_OF_THE_ABOVE') {
            options.push('None of the Above')
        }
        if (clinicalConditionOptions === 'NUMBNESS') {
            options.push('Numbness')
        }
        if (clinicalConditionOptions === 'OSTEOMYELITIS') {
            options.push('Osteomyelitis')
        }
        if (clinicalConditionOptions === 'OTHER') {
            options.push('Other')
        }
        if (clinicalConditionOptions === 'PERMANENT_IMPAIRMENT') {
            options.push(
                'Permanent impairment (requiring permanent professional medical treatment) please provide clarification'
            )
        }
        if (clinicalConditionOptions === 'PERMANENT_PAIN') {
            options.push('Permanent pain')
        }
        if (clinicalConditionOptions === 'PROLONGED_SURGERY') {
            options.push('Prolonged surgery (please specify)')
        }
        if (clinicalConditionOptions === 'PROLONGED_TREATMENT_TIME') {
            options.push('Prolonged treatment time (please specify)')
        }
        if (
            clinicalConditionOptions ===
            'REVISION_SURGERY_ASSEMBLY_ABUTMENT_IMPLANT'
        ) {
            options.push(
                'Revision surgery of the assembly (abutment and implant)'
            )
        }
        if (
            clinicalConditionOptions === 'REVISION_SURGERY_IMPLANT_EXTRACTION'
        ) {
            options.push('Revision surgery (implant extraction)')
        }
        if (clinicalConditionOptions === 'SINUS_PERFORATION') {
            options.push('Sinus perforation')
        }
        if (clinicalConditionOptions === 'SWALLOWING_MEDICAL_DEVICE') {
            options.push('Swallowing (medical device)')
        }
        if (clinicalConditionOptions === 'TRANSIENT_PAIN') {
            options.push('Transient Pain')
        }
        return options
    } else {
        return undefined
    }
}

const mapAbutmentInfo = (
    complaint: ComplaintState,
    complaintRequest: QualityNotificationRequest
) => {
    if (complaintRequest.implant) {
        // Abutment information: Which implant was used in combination with the abutment?
        complaintRequest.implant.implantType = mapComplaintImplantTypes(
            complaint.abutmentsInfo.implantBrandUsed
        )

        // Abutment information: Article number (optional):
        complaintRequest.implant.articleNo =
            complaint.abutmentsInfo.articleNumber?.trim().length === 0
                ? 'Not Available'
                : complaint.abutmentsInfo.articleNumber?.trim()

        // Abutment information: Batch / lot number (optional):
        complaintRequest.implant.batchNo =
            complaint.abutmentsInfo.batchOrLotNumber?.trim().length === 0
                ? 'Not Available'
                : complaint.abutmentsInfo.batchOrLotNumber?.trim()
    }

    return complaintRequest
}

const mapComplaintImplantTypes = (implantType: ImplantBrandOptions) => {
    if (implantType) {
        switch (implantType) {
            case 'ORIGINAL_NOBEL_BIOCARE':
                return 'Original'
            case 'NON_NOBEL_BIOCARE':
                return 'NonNobel'
            case 'UNKNOWN':
                return 'Unknown'
        }
    } else {
        return undefined
    }
}

const mapInstrumentInfo = (
    complaint: ComplaintState,
    complaintRequest: QualityNotificationRequest
) => {
    if (complaintRequest.implant) {
        // Instrument information: Number of times used:
        complaintRequest.implant.implantSitePreparationToolInitialNumberOfTimesUsed =
            complaint.instrumentInfo.numberOfTimesUsed?.toString()
    }

    if (complaintRequest.instrument) {
        // Instrument information: Age of device in years:
        complaintRequest.instrument.age =
            complaint.instrumentInfo.ageOfDevice?.toString()
    }

    return complaintRequest
}

const mapSecondaryDeviceInfo = (
    complaint: ComplaintState,
    complaintRequest: QualityNotificationRequest
) => {
    if (complaintRequest.implant) {
        // Secondary device: Was there a secondary device?
        complaintRequest.implant.secondaryDevice =
            complaint.secondaryDevice.hasSecondaryDevice === 'YES'

        // Secondary device: Enter article number or description
        complaintRequest.implant.secondaryDeviceMaterialNumber =
            complaint.secondaryDevice.selectedProduct?.productId

        // Secondary device: Batch or lot number:
        complaintRequest.implant.secondaryDeviceBatch =
            complaint.secondaryDevice.batchOrLotNumber

        // Secondary device: Do you need a replacement for the secondary device?
        complaintRequest.implant.secondaryDeviceReplacementRequired =
            complaint.secondaryDevice.isReplacementNeeded === 'YES'
    }

    return complaintRequest
}

const mapMainProductAvailableToReturn = async (
    complaint: ComplaintState,
    complaintRequest: QualityNotificationRequest
) => {
    if (complaintRequest.product) {
        // Main product - available to return: Is the product available to be returned?
        complaintRequest.product.returnAvailability =
            complaint.availableToReturn.canItemBeReturned === 'YES'

        // Main product - available to return: I confirm that product will be decontaminated before shipping to Nobel Biocare (required).
        complaintRequest.product.sterilization =
            complaint.availableToReturn.confirmDecontamination

        // Main product - available to return: Please explain why the product cannot be returned:
        complaintRequest.product.missingExplanation =
            complaint.availableToReturn.reasonItemCannotBeReturned

        if (complaint.availableToReturn.attachmentId) {
            const file = await db.attachments.get(complaint.availableToReturn.attachmentId)

            if (file) {
                const binary = btoa(await readAsBinaryStringAsync(file.content) as string)

                complaintRequest.attachments = [...(complaintRequest.attachments || []), {
                    name: `xray.${file.name.split('.')[file.name.split('.').length - 1]}`,
                    content: binary
                }]
            }
        }
    }

    return complaintRequest
}

const mapProductReplacements = (
    complaint: ComplaintState,
    complaintRequest: QualityNotificationRequest
) => {
    if (complaintRequest.mainProductReplacement) {
        // Main product replacement: Enter article number or description
        complaintRequest.mainProductReplacement.articleNo =
            complaint.replacements.selectedMainProductReplacement?.productId.trim().length === 0
            && complaint.generalComplaint.isReplacementNeeded === 'YES'
                ? 'Not Available'
                : complaint.replacements.selectedMainProductReplacement?.productId.trim().length === 0
                && complaint.generalComplaint.isReplacementNeeded === 'NO'
                    ? ''  // 20241122 Justin S. This is fine, but it still validates as True when checking if we need a return, so I'm adding an additional check on the ShippingInfo page
                    : complaint.replacements.selectedMainProductReplacement?.productId.trim()

        complaintRequest.mainProductReplacement.description =
            complaint.replacements.selectedMainProductReplacement?.shortDescription
    }

    if (complaintRequest.implant) {
        // Secondary product replacement: Enter article number or description
        complaintRequest.implant.secondaryDeviceReplacementMaterial = complaint.secondaryDevice.isReplacementNeeded
            ? complaint.replacements.selectedSecondaryDeviceReplacement?.productId
            : undefined
    }

    return complaintRequest
}

const mapAcknowledgement = (complaint: ComplaintState, complaintRequest: QualityNotificationRequest) => {
    if (complaintRequest.customer) {
        complaintRequest.customer.id = complaint.guestInfo.customerNumber || complaint.shippingInfo.customer?.customer
        complaintRequest.customer.name = complaint.shippingInfo.customer?.name1
        complaintRequest.customer.street = complaint.shippingInfo.shippingAddress?.street
        complaintRequest.customer.zip = complaint.shippingInfo.shippingAddress?.postalCode
        complaintRequest.customer.city = complaint.shippingInfo.shippingAddress?.city
        complaintRequest.customer.state = complaint.shippingInfo.shippingAddress?.region
        complaintRequest.customer.country = complaint.shippingInfo.shippingAddress?.country
        complaintRequest.customer.email = complaint.guestInfo.email || complaint.shippingInfo.customer?.emailAddress || sessionStorage.getItem('email')
        complaintRequest.customer.phone = complaint.shippingInfo.shippingAddress?.telephone
        complaintRequest.customer.shipTo = complaint.shippingInfo.shippingAddress?.customer
    }

    complaintRequest.termsAndConditions = complaint.shippingInfo.hasAcceptedTerms

    return complaintRequest
}

const getDefaultComplaintRequest = (): QualityNotificationRequest => {
    return {
        customerNumber: undefined,
        countryCode: undefined,
        issue: {
            productType: undefined,
            issueDefinition: undefined,
            issueDefinitionOther: undefined,
            patientUsed: undefined,
        },
        product: {
            productReplacementRequired: undefined,
            articleNo: undefined,
            batchNo: undefined,
            description: undefined,
            toothPosition: undefined,
            returnAvailability: undefined,
            missingExplanation: undefined,
            sterilization: undefined,
        },
        implant: {
            implantOpenedOrDroppedByError: undefined,
            articleNo: undefined,
            batchNo: undefined,
            secondaryDevice: undefined,
            secondaryDeviceMaterialNumber: undefined,
            secondaryDeviceBatch: undefined,
            implantSitePreparationToolInitialNumberOfTimesUsed: undefined,
            implantType: undefined,
        },
        instrument: {
            age: undefined,
        },
        customer: {
            id: undefined,
            name: undefined,
            street: undefined,
            zip: undefined,
            city: undefined,
            state: undefined,
            country: undefined,
            phone: undefined,
            contactName: undefined,
            alternatePhone: undefined,
            shipTo: undefined,
        },
        patient: {
            code: undefined,
            age: undefined,
            gender: undefined,
            implantHygiene: undefined,
            injured: undefined,
            injuryType: undefined,
            injuryTypeText: undefined,
            status: undefined,
        },
        clinicalProcedure: {
            eventDate: undefined,
            placementDate: undefined,
            neverPlaced: undefined,
            secondSurgeryDate: undefined,
            implantLoadDate: undefined,
            implantLoadDateUnknown: undefined,
            noImplantLoad: undefined,
            removeDate: undefined,
            removed: undefined,
            painNumbnessOffAtRemoval: undefined,
            involvedConditions: undefined,
            involvedConditionOther: undefined,
            prolongedSurgery: undefined,
            prolongedTreatmentTime: undefined,
            boneQuality: undefined,
        },
        termsAndConditions: undefined,
        mainProductReplacement: {
            articleNo: undefined,
            description: undefined,
        },
    }
}

export default prepareComplaintRequestData
